import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/context/auth';

interface PurchaseItem {
  id: string;
  title: string;
  cost: number;
  description: string;
}

export function useCoins() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: coins = 0 } = useQuery({
    queryKey: ['coins', user?.id],
    queryFn: async () => {
      const { data } = await supabase
        .from('user_profiles')
        .select('career_coins')
        .eq('user_id', user?.id)
        .single();
      
      return data?.career_coins || 0;
    },
    enabled: !!user?.id
  });

  const purchaseItem = async (item: PurchaseItem) => {
    if (!user?.id) throw new Error('User not authenticated');
    if (coins < item.cost) throw new Error('Insufficient coins');

    const { error } = await supabase
      .from('user_profiles')
      .update({
        career_coins: coins - item.cost,
        purchased_items: supabase.sql`array_append(purchased_items, ${item.id})`
      })
      .eq('user_id', user.id);

    if (error) throw error;

    // Invalidate coins query to trigger refresh
    await queryClient.invalidateQueries({ queryKey: ['coins', user.id] });
  };

  return {
    coins,
    purchaseItem
  };
}